<template>
    <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <h1 :style="`color:${mainColor}`">Colaboradores</h1>
                    </v-row>
                </v-col>
                <v-col class="text-center" cols="12" v-if="onLoading">
                    <loading-circular/>
                </v-col>
            </v-row>
            <v-row class="mb-5 mt-2"   >
              <v-col cols="2" offset="10" v-if="collabs.length > 0">
                <v-row class="pb-2 pr-5">
                    <add-collab-dialog :user="{companyId:companyId}"/>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-5" v-if="collabs.length === 0 ">
              <v-col cols="12">
                  <add-collab-dialog :user="{companyId:companyId}"/>
              </v-col>
            </v-row>
            <v-row  >
                <v-col cols="8" offset="2" v-for="(collab, index) in collabs" :key="index" class="mb-5">
                    <v-card :style="{color:style.fontColor}" hover>
                        <v-container fluid style="cursor: default">
                            <v-row class="pb-1">
                                <v-col cols="4" class="pt-0">
                                    <v-card-title primary-title>
                                        <div>
                                            <h3>{{collab.firstName}}</h3>
                                        </div>
                                    </v-card-title>
                                    <v-img
                                        :src="collab.photoUrl === '' ? addImageIcon : collab.photoUrl"
                                        height="125px"
                                        aspect-ratio="1"
                                        contain
                                    ></v-img>
                                </v-col>
                                <v-col cols="5" class="pt-11">
                                    <v-card-text primary-title class="pt-5 ml-3">
                                        <div>
                                            <h4 class="mb-0">{{`NOMBRE: ${collab.firstName} ${collab.lastName}`}}</h4>
                                        </div>
                                    </v-card-text>
                                    <v-card-text primary-title class="pt-3 ml-3">
                                        <div>
                                            <h4 class="mb-0">{{`EMAIL: ${collab.email}`}}</h4>
                                        </div>
                                    </v-card-text>
                                    <v-card-text primary-title class="pt-3 ml-3">
                                        <div>
                                            <h4 class="mb-0">{{'DESDE: '}}{{new Date(collab.creationDate.seconds * 1e3).toString() | dateFilter}}</h4>
                                        </div>
                                    </v-card-text>
                                </v-col>
                                <v-col cols="3" class="pt-11">
                                    <v-card-actions class="ml-5">
                                        <v-col class="text-right" >
                                            <edit-collab-dialog :user="collab"/>
                                        </v-col>
                                    </v-card-actions>
                                    <v-card-actions class="ml-5">
                                      <v-row>
                                        <v-col class="text-right" >
                                            <v-tooltip
                                                bottom
                                                >
                                                <template v-slot:activator="{on}">
                                                  <v-btn
                                                   @click="deleteCollab(collab.collabId, collab.email)"
                                                   :color="mainColor"
                                                   outlined
                                                   icon
                                                   v-on="on">
                                                      <v-icon>{{deleteIcon}}</v-icon>
                                                  </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>

                                        </v-col>
                                      </v-row>
                                    </v-card-actions>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
/* eslint-disable no-console */
import * as constants from '../../../constants.json'
import { mdiPencilOutline, mdiDeleteOutline } from '@mdi/js'

export default {
  data () {
    return {
      collabs: [],
      companyId: '',
      userId: '',
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      editIcon: mdiPencilOutline,
      deleteIcon: mdiDeleteOutline,
      addImageIcon: constants.ADD_IMAGE_ICON
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    user () {
      return this.$store.getters.getUser
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    }
  },

  watch: {
    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      // eslint-disable-next-line
      console.log('value', value)
      if (value === null || value === undefined || value.role === 'editor') {
        this.$router.push('/')
      } else {
        await this.fetchData()
      }
    }
  },

  created () {
    // Fetching the data when the view is created and the data is already being observed
    this.fetchData()
  },

  methods: {
    async fetchData () {
      try {
        const user = this.$store.getters.getUser
        if (user) {
          if (user.role === 'mega_administrator') {
            this.companyId = localStorage.companyId
          } else {
            const companyData = this.$store.getters.getCompanyData
            this.companyId = companyData.companyId
          }

          await this.$store.dispatch('actionLoadCollabs', { companyId: this.companyId })
          this.collabs = this.$store.getters.getLoadedCollabs
          console.log('companyId: ', this.companyId)
        }
      } catch (error) {
        throw error
      }
    },

    async deleteCollab (collabId, email) {
      try {
        confirm('¿Deseas eliminar este usuario?') && await this.$store.dispatch('actionDeleteCollab', { companyId: this.companyId, collabId, email })
      } catch (error) {
        throw error
      }
    }
  }
}
</script>
